@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.breadcrumbs {
  display: flex;
  align-items: center;
  min-height: 45px;
  padding-left: 24px;
  border-bottom: 1px solid @insights-page--breadcrumbs--border-color;
  background: @insights-page--breadcrumbs--background-color;
}

.separator {
  height: 10px;
  width: 10px;
}
